<template #default>
    <div class="widget-container">
        <!-- <h2 class="content-block">New Order</h2> -->
        <div class="content-block dx-card responsive-paddings">
            <form action="action" @submit.prevent="onFormSubmit">
            <DxForm ref="form4" id="form" :form-data="formData" label-mode="floating">
                <DxGroupItem :col-count="2" :caption="$t('registration.version')">
                <DxSimpleItem data-field="Version"
                    :validation-rules="NumberValidationRules">
                    <dx-label :text="$t('registration.version')" />
                </DxSimpleItem>
                </DxGroupItem>

                <DxGroupItem :col-count="2" :caption="$t('registration.general')">
                <DxSimpleItem data-field="Year" :validation-rules="NumberValidationRules" editor-type="dxSelectBox" :editor-options="yearEditorOptions">
                    <dx-label :text="$t('registration.year')" />
                </DxSimpleItem>

                <DxSimpleItem data-field="Quarter" :validation-rules="NumberValidationRules" editor-type="dxSelectBox" :editor-options="quarterEditorOptions">
                    <dx-label :text="$t('registration.quarter')" />
                </DxSimpleItem>
                </DxGroupItem>

                <DxGroupItem :caption="$t('registration.uimForecast')" :col-count="1">
                <DxSimpleItem name="UIMForecastGrid">
                    <template #default>
                    <DxDataGrid ref="UIMForecastRef" id="grid-container1" :show-borders="true"
                        :data-source="UIMForecastData" :row-alternation-enabled="true"
                        :hover-state-enabled="true" :selection="{ mode: 'multiple' }"
                        @saved="onRowSaved($event)"
                        :column-hiding-enabled="true" key-expr="Id">
                        <DxEditing :allow-deleting="true" :allow-adding="true" mode="form">
                        </DxEditing>
                        <DxColumn
                            data-field="Product_Id"
                            :caption="$t('registration.product')">
                            <DxLookup
                                :data-source="ProductOptions"
                                value-expr="Id"
                                display-expr="Name"/>
                            <DxRequiredRule />
                        </DxColumn>
                        <DxColumn
                            data-field="Month"
                            :caption="$t('registration.month')">
                            <DxLookup
                                :data-source="FilteredMonthOptions"
                                value-expr="Id"
                                display-expr="Name"/>
                            <DxRequiredRule />
                        </DxColumn>
                        <DxColumn data-field="UIMForecast" format="#,##0.##">
                        <DxFormItem
                        editor-type="dxNumberBox"
                        />
                        <DxRequiredRule />
                        </DxColumn>
                        <DxColumnFixing :enabled="false" />
                        <DxGroupPanel :visible="true" />
                    </DxDataGrid>
                    </template>
                </DxSimpleItem>
                </DxGroupItem>
                <DxGroupItem :col-count="2" :caption="$t('registration.totalForecast')">
                <DxSimpleItem data-field="TotalForecast"  :validation-rules="NumberValidationRules"
                 :editor-options="{ readOnly: true, format: '#,##0.##' }">
                    <dx-label :text="$t('registration.totalForecast')" />
                </DxSimpleItem>
                </DxGroupItem>
                    <DxGroupItem :col-count="1">
                        <DxButtonItem :button-options="buttonOptions" horizontal-alignment="right" />
                    </DxGroupItem>
                <br><br>
            </DxForm>
            </form>
        </div>
    </div>
</template>

<script>
import DxForm, {
    DxGroupItem,
    DxSimpleItem,
    DxButtonItem,
    DxLabel,
    // DxItemPanel,
    // DxItem,    
    DxRequiredRule,
    DxCompareRule,
    DxRangeRule,
    DxStringLengthRule,
    DxPatternRule,
    DxEmailRule,
    DxAsyncRule,
} from 'devextreme-vue/form'

import DxCheckBox from 'devextreme-vue/check-box';
import DxTooltip from 'devextreme-vue/tooltip';

import DxItemPanel from "devextreme-vue/tab-panel"
import DxAutocomplete from 'devextreme-vue/autocomplete'
import {
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxToolbar,
    DxItem,
    DxFormItem,
    DxLookup,
    DxMasterDetail,
    DxColumnFixing,
    DxGroupPanel,
} from 'devextreme-vue/data-grid'

import DxRadioGroup from 'devextreme-vue/radio-group'

import DxButton from 'devextreme-vue/button'

import notify from 'devextreme/ui/notify'
import dateUtil from '@/helpers/dateUtil'

import { mapState, mapActions } from 'vuex'

import {
    POST_UIM_FORECAST_DETAILS, GET_REVENUE_SOURCE
} from '@/store/_actiontypes'

export default {
    components: {
        DxGroupItem,
        DxSimpleItem,
        DxButtonItem,
        DxButton,
        DxRadioGroup,
        DxLabel,
        DxItemPanel,
        DxItem,
        DxDataGrid,
        DxColumn,
        DxEditing,
        DxFormItem,
        DxLookup,
        DxMasterDetail,
        DxToolbar,
        DxRequiredRule,
        DxCompareRule,
        DxPatternRule,
        DxRangeRule,
        DxEmailRule,
        DxStringLengthRule,

        DxCheckBox,
        DxTooltip,

        DxForm,
        DxAutocomplete,
        DxAsyncRule,
        DxColumnFixing,
        DxGroupPanel,

        notify,
    },

    data() {
        const incorporationData = {}
        const status = [
            {
                Id: 'Former',
                Name: 'Former'
            },
            {
                Id: 'Current',
                Name: 'Current'
            }
        ]

        return {
            CDP: {},
            ProductOptions: [],
            LastSelectedProduct: '',
            dataOperation: ['New', 'Update'],
            statusEditorOptions: status,
            UIMForecastData: [],
            AuditedAccountsData: [],
            CurrentCompanySecretariesData: [],
            DirectorsReportsData: [],
            AuditorsReportsData: [],
            OrderItemsData: [],
            AppointmentOfAuditorsData: [],
            ReasonOfTermination: [],
            accPeriod: '', extract: '', extractDate: '',
            dateOptions: { displayFormat: "dd-MM-yyyy" },
            selectedTabIndex: 0,
            isOrderVisible: true,
            formData: {
                TotalForecast: 0,
                Year: new Date().getFullYear(),
                Quarter: null
            },

            accountingPeriodOptions: {
                disabled: false,
                onValueChanged: e => {
                    //this.saveAccountingPeriodValue(e)
                },
            },
            extractOptions: {
                height: 70,
                onValueChanged: e => {
                    //this.saveExtractOfResolutionValue(e)
                },
            },

            incorporationData,
        }
    },

    computed: {
        ...mapState({
            payerId: state => state?.user?.user?.data?.payer?.id
        }),
        NumberValidationRules() {
        return [
            {
            type: 'required',
            message: this.$t('registration.yearRequired')
            },
            {
            type: 'pattern',
            pattern: /^[0-9]+$/,
            message: this.$t('registration.yearRequired')
            }
        ]
        },
        YearOptions() {
            const currentYear = new Date().getFullYear();
            return [
                {
                    Id: currentYear,
                    Name: currentYear.toString()
                },
                {
                    Id: currentYear + 1,
                    Name: (currentYear + 1).toString()
                }
            ];
        },
        QuarterOptions() {
            const currentYear = new Date().getFullYear();
            const currentDate = new Date();
            const currentMonth = currentDate.getMonth() + 1; // 1-12
            
            // If current year is selected, only show quarters for months that haven't started yet
            if (this.formData.Year === currentYear) {
                const quarters = [];
                
                // Calculate which quarters are still available (months not started yet)
                if (currentMonth < 4) {
                    // Before April - Q1, Q2, Q3, Q4 available
                    quarters.push(
                        { Id: 1, Name: 'Quarter 1' },
                        { Id: 2, Name: 'Quarter 2' },
                        { Id: 3, Name: 'Quarter 3' },
                        { Id: 4, Name: 'Quarter 4' }
                    );
                } else if (currentMonth < 7) {
                    // April to June - Q2, Q3, Q4 available (Q1 started)
                    quarters.push(
                        { Id: 2, Name: 'Quarter 2' },
                        { Id: 3, Name: 'Quarter 3' },
                        { Id: 4, Name: 'Quarter 4' }
                    );
                } else if (currentMonth < 10) {
                    // July to September - Only Q4 available (Q1, Q2, Q3 started)
                    quarters.push({ Id: 4, Name: 'Quarter 4' });
                } else {
                    // October onwards - Only Q4 available (Q1, Q2, Q3 started)
                    quarters.push({ Id: 4, Name: 'Quarter 4' });
                }
                
                return quarters;
            }
            
            // If future year is selected, show all quarters
            return [
                { Id: 1, Name: 'Quarter 1' },
                { Id: 2, Name: 'Quarter 2' },
                { Id: 3, Name: 'Quarter 3' },
                { Id: 4, Name: 'Quarter 4' }
            ];
        },
        MonthOptions() {
        return [
            {
            Id: "1",
            Name: this.$t('months.january')
            },
            {
            Id: "2",
            Name: this.$t('months.february')
            },
            {
            Id: "3",
            Name: this.$t('months.march')
            },
            {
            Id: "4",
            Name: this.$t('months.april')
            },
            {
            Id: "5",
            Name: this.$t('months.may')
            },
            {
            Id: "6",
            Name: this.$t('months.june')
            },
            {
            Id: "7",
            Name: this.$t('months.july')
            },
            {
            Id: "8",
            Name: this.$t('months.august')
            },
            {
            Id: "9",
            Name: this.$t('months.september')
            },
            {
            Id: "10",
            Name: this.$t('months.october')
            },
            {
            Id: "11",
            Name: this.$t('months.november')
            },
            {
            Id: "12",
            Name: this.$t('months.december')
            }
        ]
        },
        FilteredMonthOptions() {
            if (!this.formData.Quarter) {
                return this.MonthOptions;
            }
            
            const quarterStartMonth = (this.formData.Quarter - 1) * 3 + 1;
            const quarterEndMonth = this.formData.Quarter * 3;
            
            return this.MonthOptions.filter(month => {
                const monthNum = parseInt(month.Id);
                return monthNum >= quarterStartMonth && monthNum <= quarterEndMonth;
            });
        },
        yearEditorOptions() {
            return {
                dataSource: this.YearOptions,
                valueExpr: 'Id',
                displayExpr: 'Name',
                onValueChanged: this.onYearChanged
            };
        },
        quarterEditorOptions() {
            return {
                dataSource: this.QuarterOptions,
                valueExpr: 'Id',
                displayExpr: 'Name',
                onValueChanged: this.onQuarterChanged
            };
        },
        buttonOptions() {
            return {
            text: this.$t('orderAdd.save'),
            type: 'normal',
            useSubmitBehavior: true
            }
        },
        checkBoxOptions() {
        return {
            text: this.$t('registration.iAmForeigner'),
            onValueChanged: (e) => {
            this.passwordVisibility = e.component.option('value');
            this.formData.Foreigner = e.component.option('value');
            },
        }
        }
    },

    created() {
        this.loadRevenueSourceData()
        // Set initial quarter based on current date
        this.setInitialQuarter();
    },

    methods: {
        ...mapActions("application", [  POST_UIM_FORECAST_DETAILS ]),

        ...mapActions("payment", [ GET_REVENUE_SOURCE ]),

        onRowSaved(e) {
            const totalUIMForecast = this.UIMForecastData.reduce((sum, item) => sum + Number(item.UIMForecast), 0);
            this.formData.TotalForecast = Number(totalUIMForecast);
        },

        setInitialQuarter() {
            const currentDate = new Date();
            const currentMonth = currentDate.getMonth() + 1; // 1-12
            
            // Set the first available quarter based on current month
            if (currentMonth < 4) {
                this.formData.Quarter = 1; // Q1 available
            } else if (currentMonth < 7) {
                this.formData.Quarter = 2; // Q2 available
            } else if (currentMonth < 10) {
                this.formData.Quarter = 4; // Only Q4 available (Q1, Q2, Q3 started)
            } else {
                this.formData.Quarter = 4; // Only Q4 available
            }
        },

        onYearChanged(e) {
            this.formData.Year = e.value;
            // Reset quarter when year changes
            this.formData.Quarter = null;
            // Set appropriate quarter based on new year
            if (this.formData.Year === new Date().getFullYear()) {
                this.setInitialQuarter();
            } else {
                this.formData.Quarter = 1; // Default to Q1 for future years
            }
        },

        onQuarterChanged(e) {
            this.formData.Quarter = e.value;
        },

        onFormSubmit() {
            if (this.UIMForecastData.length) {

            let payload = {
              details: this.UIMForecastData
            }
            let _payload = { ...payload, ...this.formData };

                this.POST_UIM_FORECAST_DETAILS(_payload).then(res => {
                    this.$router.push('/forecasts')
                    this.$toast.success(this.$t('orders.orderProcessedSuccess'))
                })
                .catch(error => {
                    console.log(error)
                    this.$toast.error(error?.data?.errors?.message || this.$t('errors.unexpectedError'));
                })
            }
            else {
                this.$toast.error(this.$t('orders.orderItemRequired'))
            }
        },

        loadRevenueSourceData() {
            this.GET_REVENUE_SOURCE().then(res => {
                this.ProductOptions = res.data?.body[0]?.sources.map((item, index) => {
                    return {
                        Id: item.id,
                        Name: item.source_name,
                        Rate: item.rate,
                        Currency: item.currency,
                        Min_qty: item.min_qty
                    }
                })
            })
            .catch(error => {
                console.log(error)
            })
        },

        handleShippingMethod(e) {

        },

        handleShipToLocation(e) {
            this.formData.Facility = e.value
            console.log(this.formData)
        },
        selectShippingMethod(method) {
            // this.formData.selectedShippingMethod = method;
        },

        loadRevenueSourceData() {
            this.GET_REVENUE_SOURCE().then(res => {
                this.ProductOptions = res.data?.body[0]?.sources.map((item, index) => {
                    return {
                        Id: item.id,
                        Name: item.source_name,
                        Rate: item.rate,
                        Currency: item.currency,
                        Min_qty: item.min_qty
                    }
                })
            })
            .catch(error => {
                console.log(error)
            })
        },
    }
}
</script>
<style scoped>
.shipping-option {
    display: flex;
    flex-direction: column;
    border: 1px solid #ccc;
    padding: 10px;
    border-radius: 5px;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    margin-bottom: 10px;
    /* Space between options */
}

.shipping-option.selected {
    border-color: #007bff;
    /* Highlight selected option */
    background-color: #eaf5ff;
    /* Light blue background for selected */
}

.checkbox-container {
    display: flex;
    align-items: center;
    margin-bottom: 5px;
}

.dx-checkbox {
    margin-right: 8px;
    /* Space between checkbox and label */
}

.shipping-label {
    font-weight: bold;
}

.delivery-info {
    font-size: 0.9em;
    color: #666;
    margin-left: 28px;
    /* Align with the text above, considering checkbox width */
}

.info-icon-standard {
    margin-left: 5px;
    cursor: help;
    color: #888;
}
</style>